<template>
  <div class="profile-dropdown">
    <span aria-hidden="true" class="fa fa-user-circle i-nav-user icon" />

    <vuestic-dropdown v-if="id_role == 4" v-model="isShown" position="bottom">
      <router-link :to="{ name: 'aluno' }" class="dropdown-item" href="#">
        <b class="extras">Perfil</b>
      </router-link>

      <!-- <div>
        <a href="#" class="dropdown-item" @click="showTableReg"><b class="extras">Aulas Regulares</b></a>
      </div>

      <div>
        <a href="#" class="dropdown-item" @click="showTableRep"><b class="extras">Aulas Reposição</b></a>
      </div> -->

      <div>
        <a href="#" class="dropdown-item" @click="logoutAluno"><b class="extras">Sair</b></a>
      </div>
    </vuestic-dropdown>

    <vuestic-dropdown v-else-if="id_role == 3" v-model="isShown" position="bottom">
      <a href="#" class="dropdown-item" @click="logoutInstrutor"><b>Sair</b></a>
    </vuestic-dropdown>

    <vuestic-dropdown v-else v-model="isShown">
      <div v-show="id_role != 9" v-for="option in options" :key="option.name">
        <router-link :to="{name: option.redirectTo}" class="dropdown-item" href="#" v-if="schema == 'public' && id_role == 1">
          <i :class="option.icon" style="padding-right: 10px; color: #FFCF41;"></i>
          <b>{{ option.name }}</b>
        </router-link>

        <router-link :to="{name: option.redirectTo}" class="dropdown-item" href="#" v-else-if="option.name !== 'Configurações'">
          <i :class="option.icon" style="padding-right: 10px; color: #FFCF41;"></i>
          <b>{{ option.name }}</b>
        </router-link>
      </div>

      <a href="#" class="dropdown-item linkButton" style="padding-left:10px;" @click="config()" v-show="schema == 'public'">
        <i class="fa fa-gear" style="padding-right: 10px; color: #FFCF41;"></i>
        <b>Configurações</b>
      </a>

      <a href="#" class="dropdown-item" @click="logout">
        <i class="fa fa-sign-out" style="padding-right: 10px; color: #FFCF41;"></i>
        <b style="margin-right: 10px;">Sair</b>
      </a>
    </vuestic-dropdown>
  </div>
</template>

<script>
import router from '../../../../../router'
import { Auth } from '../../../../../services/auth'

export default {
  name: 'profile-section',
  data () {
    return {
      isShown: false,
      aula: '',
      profileShow: false,
      id_role: localStorage.id_role,
      schema: localStorage.schema
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [
        {
          name: 'Salas',
          redirectTo: 'listagem-salas',
          icon: "fa fa-users"

        },
        {
          name: 'Câmeras',
          redirectTo: 'listagem-cameras',
          icon: "fa fa-camera"
        },
        // {
        //   name: 'Configurações',
        //   redirectTo: 'permissoes',
        //   icon: "fa fa-gear"
        // },
      ],
    },
  },
  methods: {
    logout: function () {
      Auth.logout()
    },
    logoutAluno: function () {
      Auth.logoutAluno()
    },
    logoutInstrutor: function () {
      Auth.logoutInstrutor()
    },
    config() {
      router.push({ name: 'permissoes' });
    },
    showTableRep(){
      this.aula = 1

      this.$router.push({
        name: 'aulas',
        params: {
          status: this.aula
        }
      })
    },
    showTableReg(){
      this.aula = 0

      this.$router.push({
        name: 'aulas',
        params: {
          status: this.aula
        }
      })
    },
    showPerfil(){
      this.profileShow = true

      this.$router.push({
        name: 'aluno'
      })
    }
  }
}
</script>

<style lang="scss">
@import '../../../../../vuestic-theme/vuestic-sass/resources/resources';

.profile-dropdown {
  @include flex-center();
  cursor: pointer;

  @at-root {
    .notification-dropdown__list {
      width: 250px;
    }
    .extras{
    color: white;
    font: bold;
    }
  .extras:hover{
    color: white;
    font: bold;
    }
  }

  .i-nav-user{
    position: relative;
    color: white;
    font-size: 35px;
  }
}
</style>
